module.exports = __webpack_public_path__ + "static/media/php-intermediate.5eadedcc.png";